import { Component, OnInit } from '@angular/core';
import { PaymentMethodService } from '../../../services/payment-method.service';
import { LoadingService } from '../../../services/loading.service';
import { AuditInfo } from '../../../interfaces/audit.interfaces';

interface PaymentMethod {
  id: number;
  name: string;
  isBankTransfer: boolean;
  isPaymentGateway: boolean;
  gatewayProvider?: string | null;
  isIntegrated: boolean;
  requiresLinkGeneration: boolean;
  createdAt?: string;
  updatedAt?: string;
}

@Component({
  selector: 'app-payment-methods',
  templateUrl: './payment-methods.component.html',
  styleUrls: ['./payment-methods.component.scss']
})
export class PaymentMethodsComponent implements OnInit {
  paymentMethods: PaymentMethod[] = [];
  filteredPaymentMethods: PaymentMethod[] = [];

  searchTerm: string = '';

  constructor(
    private paymentMethodService: PaymentMethodService,
    private loadingService: LoadingService
  ) {}

  ngOnInit(): void {
    this.loadPaymentMethods();
  }

  private loadPaymentMethods(): void {
    this.loadingService.show();
    this.paymentMethodService.getAll().subscribe({
      next: (response) => {
        // Manejar estructura paginada: data puede ser array directo o {data: [...], totalCount: ...}
        const data = response?.data;
        this.paymentMethods = Array.isArray(data) ? data : (data?.data || []);
        this.filteredPaymentMethods = [...this.paymentMethods];
        this.loadingService.hide();
      },
      error: (err) => {
        console.error(err);
        this.loadingService.hide();
      }
    });
  }

  applyFilters(): void {
    const search = this.searchTerm.toLowerCase();
    this.filteredPaymentMethods = this.paymentMethods.filter(paymentMethod =>
      paymentMethod.name.toLowerCase().includes(search) ||
      (paymentMethod.isBankTransfer ? 'transferencia' : 'efectivo').toLowerCase().includes(search)
    );
  }

  getAuditData(paymentMethod: PaymentMethod): AuditInfo {
    const anyPaymentMethod = paymentMethod as any;
    return {
      createdBy: anyPaymentMethod?.createdBy,
      createdAt: anyPaymentMethod?.createdAt,
      updatedBy: anyPaymentMethod?.updatedBy,
      updatedAt: anyPaymentMethod?.updatedAt,
      deletedBy: anyPaymentMethod?.deletedBy,
      deletedAt: anyPaymentMethod?.deletedAt,
      isDeleted: anyPaymentMethod?.isDeleted
    };
  }
}
